<template>
  <report :title="$t('language.monthlyledger')" :filter="filter" :url="url">
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.month')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.month"
            :items="MonthList"
            item-text="name"
            item-value="id"
            :label="$t('language.month')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.person')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.personid"
            :items="PersonList"
            item-text="name"
            item-value="id"
            :label="$t('language.person')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}</td>
            <td></td>
            <td>{{ $t("language.month") }}:{{ selectedmonth }}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th>{{ $t("language.date") }}</th>
            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.dutyhour") }}</th>
            <th>{{ $t("language.intime") }}</th>
            <th v-if="$store.getters.settings.enablebreakinbreakout">
              {{ $t("language.breakout") }}
            </th>
            <th v-if="$store.getters.settings.enablebreakinbreakout">
              {{ $t("language.breakin") }}
            </th>
            <th>{{ $t("language.outtime") }}</th>
            <th>{{ $t("language.workedhour") }}</th>
            <th v-if="$store.getters.settings.enableot">
              {{ $t("language.ot") }}
            </th>
            <th>{{ $t("language.status") }}</th>
            <th>{{ $t("language.remarks") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.detail" :key="index">
            <td>{{ getDefaultDate(item.date) }}</td>
            <td>{{ $t("language." + item.day) }}</td>
            <td>{{ item.dutytime }}</td>
            <td>{{ item.intime }}</td>
            <td v-if="$store.getters.settings.enablebreakinbreakout">
              {{ item.breakouttime }}
            </td>
            <td v-if="$store.getters.settings.enablebreakinbreakout">
              {{ item.breakintime }}
            </td>
            <td>{{ item.outtime }}</td>
            <td>{{ item.workedhour }}</td>
            <td v-if="$store.getters.settings.enableot">{{ item.othour }}</td>
            <td>
              {{ item.status != "" ? $t("language." + item.status) : "" }}
            </td>
            <td>{{item.remarks}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th v-if="$store.getters.settings.enablebreakinbreakout"></th>
            <th v-if="$store.getters.settings.enablebreakinbreakout"></th>
            <th>{{ $t("language.total")}}</th>
            <th class="text-left">{{ data.wh.workedhour }}</th>
            <th class="text-left" v-if="$store.getters.settings.enableot">{{ data.oth.othour }}</th>
            <th></th>
            <th></th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        month: commonservice.getCurrentMonth(),
        personid: null,
      },
      YearList: [],
      MonthList: commonservice.getMonthList(),
      PersonList: [],
      url: "client/report/monthly/ledgers",
    };
  },
  computed: {
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedmonth() {
      if (this.filter.month == null) return this.$t("language.all");
      return this.MonthList.filter((c) => {
        return c.id == this.filter.month;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/monthly/init/list").then((response) => {
      next((p) => {
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    getDefaultDate(date) {
      return commonservice.getDefaultDate(date);
    },
  },
};
</script>
